<template>
  <div v-if="typeof this.params.value !== 'undefined'">
      B <feather-icon v-if="typeof this.params.value !== 'undefined'" icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', textColorBride]" />
    |
    V <feather-icon v-if="typeof this.params.value !== 'undefined'" icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', textColorVendor]" />
  </div>
</template>

<script>
export default {
  name: 'CellRendererFees',
  computed: {
    textColorBride () {
      return this.params.value.bride_fee ? 'text-primary' : 'text-grey'
    },
    textColorVendor () {
      return this.params.value.vendor_fee ? 'text-primary' : 'text-grey'
    }
  }
}
</script>
